// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../atoms/Icon/IconV5.bs.js");
let Avatar__Jsx3 = require("../../atoms/Avatar/Avatar__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function Chat__Jsx3$ChatAvatar(props) {
  let overlayIcon = props.overlayIcon;
  let name = props.name;
  let src = props.src;
  return JsxRuntime.jsx("div", {
    children: overlayIcon !== undefined ? JsxRuntime.jsxs("span", {
        children: [
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: overlayIcon,
              size: 20,
              className: props.iconClassName
            }),
            className: "absolute right-[-8%] top-[58%] opacity-40"
          }),
          JsxRuntime.jsx(Avatar__Jsx3.make, {
            src: src,
            name: name,
            size: "tiny"
          })
        ],
        className: "relative inline-block"
      }) : JsxRuntime.jsx(Avatar__Jsx3.make, {
        src: src,
        name: name,
        size: "tiny"
      }),
    className: "mr-2.5"
  });
}

let ChatAvatar = {
  make: Chat__Jsx3$ChatAvatar
};

exports.ChatAvatar = ChatAvatar;
/* IconV5 Not a pure module */
